import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import Footer from '../components/Footer'
import Header from '../components/Header'

class Page extends Component {
  render () {
    return (
      <div className='b-layout'>

        <Helmet title={this.props.title} />

        <Header />

        {this.props.children}

        <Footer />

      </div>
    )
  }
}

Page.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node
}

export default Page



// WEBPACK FOOTER //
// ./src/containers/Page.js